module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kdoc"
  }, _vm._l((_vm.normalizedDoc), function(n, i) {
    return _c('node-renderer', {
      key: i,
      attrs: {
        "node": n
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11d46b2c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/KeystoneDocumentRenderer.vue
// module id = 1695
// module chunks = 0